<div class="edit-unit-main">
  <div class="d-flex justify-content-between align-items-center">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="back-navigation hide"
      (click)="closeDialog()"
    />
    <div>
      <p class="building-name text-center">
        <app-with-tooltip [showHelpCursor]="true">{{
          selectedBuilding?.buildingName
        }}</app-with-tooltip>
      </p>
      <p class="modal-title text-center bold-heading mt-2">
        <app-with-tooltip [showHelpCursor]="true"
          >{{ 'UNIT' | translate }}
          {{ this.sharedData?.selectedUnit?.unitName }}</app-with-tooltip
        >
      </p>
    </div>

    <div class="col-1">
      <img
        src="/assets/svg/ico-cross.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div class="col-8">
      <h1 class="text-center heading1">
        {{ 'EDIT' | translate }}
        <p>
          {{ 'UNIT_NAME' | translate }}
        </p>
      </h1>
    </div>
  </div>

  <div class="modal-body">
    <div
      class="w-100 h-100 d-flex flex-column justify-content-center align-items-start"
    ></div>
    <form class="pb-5" [formGroup]="editUnitForm">
      <div class="form-group rounded-top form-container margin-label">
        <mat-form-field appearance="fill" class="w-100 mb-2">
          <mat-label>{{ 'UNIT_NAME_ASTERISK' | translate }}</mat-label>
          <span class="prefix mr-2" matPrefix>{{ floorPrefix }}&nbsp;</span>
          <input
            matInput
            [placeholder]="'ENTER_UNIT_Name' | translate"
            formControlName="unitName"
            oninput="validity.valid||(value='');"
          />
          <mat-error
            *ngIf="editUnitForm?.controls?.unitName?.errors?.whitespace"
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}</mat-error
          >
          <mat-error
            *ngIf="editUnitForm?.controls?.unitName?.errors?.maxlength"
          >
            {{
              commonService.stringInterPolation(
                ("MAXIMUM_OF_CHARACTERS" | translate),
                "50"
              )
            }}
          </mat-error>
          <mat-error *ngIf="editUnitForm?.controls?.unitName?.errors?.required"
            >{{ 'UNIT_NAME_IS_REQUIRES' | translate }}
          </mat-error>
          <mat-error
            *ngIf="editUnitForm?.controls?.unitName?.errors?.minlength"
            >{{ 'YOU_MUST_ENTER_MIN_TWO_CHAR' | translate }}</mat-error
          >
          <mat-error>
            <span
              *ngIf="
                editUnitForm?.controls?.unitName?.errors
                  ?.requiredSpecialCharForUnitName
              "
              >{{ 'YOU_MUST_ENTER_VALID_UNIT_NAME' | translate }}</span
            >
            <span
              *ngIf="
                editUnitForm?.controls?.unitName?.errors
                  ?.firstCharacterIsSpecialCharacter
              "
              >{{
                'UNIT_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER' | translate
              }}</span
            >
          </mat-error>

          <mat-error
            *ngIf="
              editUnitForm?.controls?.unitName?.errors
                ?.requiredSpecialCharForUnitName &&
              !editUnitForm?.controls?.unitName?.errors?.required &&
              !editUnitForm?.controls?.unitName?.errors?.whitespace &&
              !editUnitForm?.controls?.unitName?.errors?.minlength &&
              !editUnitForm?.controls?.unitName?.errors?.maxlength
            "
            >{{ 'YOU_MUST_ENTER_VALID_UNIT_NAME' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </form>
    <div class="mt-5 pt-5">
      <div class="row mt-5">
        <button
          class="btn btn-danger px-3 w-100 save-btn"
          type="button"
          tabindex="0"
          [controlDisabled]="[PageName.Unit, CONSTANTS.UPDATE]"
          [disabledCheck]="!editUnitForm.valid"
          (click)="
            editUnitHandler(
              selectedSite?.siteId,
              selectedBuilding?.buildingId,
              selectedFloor?.floorId,
              selectedUnit?.unitId,
              editUnitForm?.controls.unitName.value,
              unit?.unitStatus
            )
          "
        >
          {{ 'SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
